export enum ApiRoutesRecommendation {
  Affinity = "admin/recommendation/affinity",
  AffinityBlacklist = "admin/recommendation/affinity/blacklist",
  AffinityStatus = "admin/recommendation/affinity/status",
  AffinityGenerate = "admin/recommendation/affinity/generate",
  Learn = "admin/recommendation/learn",
  RecommendProduct = "admin/recommendation/product",
  RecommendCustomer = "admin/recommendation/customer",
  RecommendReseller = "admin/recommendation/reseller",
  Enrichment = "admin/product-enrichment",
  EnrichmentBatch = "admin/product-enrichment/batch",
  EnrichmentProfiles = "admin/product-enrichment/profiles",
  EnrichmentProfilesAvailable = "admin/product-enrichment/profiles/available",
  SuggestionDiscount = "admin/suggestion-discount/settings"
}
